import { useForm } from "@inertiajs/react";

import FormModal from "@/components/Modal/FormModal";
import TextFieldComponent from "@/components/TextField";

type ConsortiumData = {
  id: number;
  name: string;
  share_quantity: number;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  mode?: "create" | "edit";
  consortium?: Partial<ConsortiumData>;
  onSaved?: (message: string) => void;
  onError?: (message: string) => void;
};

export default function CreateConsortiumModal({
  isOpen,
  onClose,
  mode = "create",
  consortium,
  onSaved,
  onError,
}: Props) {
  const isEdit = mode === "edit";
  const form = useForm({
    name: consortium?.name || "",
    share_quantity: String(consortium?.share_quantity ?? 0),
  });
  const submit = () => {
    const onErrorRequest = (errors: Record<string, string | string[]>) => {
      onError?.(Object.values(errors).flat().join(" ") || "Não foi possível salvar a SPE.");
    };
    const onSuccess = () => {
      form.reset();
      onClose();
      onSaved?.(isEdit ? "SPE atualizada com sucesso." : "SPE criada com sucesso.");
    };

    if (isEdit && consortium?.id) {
      form.patch(`/manager/spes/${consortium.id}`, { onSuccess, onError: onErrorRequest });
    } else {
      form.post("/manager/spes", { onSuccess, onError: onErrorRequest });
    }
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? "Editar SPE" : "Adicionar SPE"}
      description="Cadastre os dados e configurações da SPE"
      submitButtonTitle={isEdit ? "Salvar alterações" : "Cadastrar SPE"}
      onSubmit={submit}
      isSubmitting={form.processing}
      size="sm"
    >
      <div className="grid grid-cols-1 gap-4">
        <TextFieldComponent
          labelPosition="top"
          label="Nome"
          required
          type="text"
          placeholder="Digite o nome da SPE"
          value={form.data.name}
          onChange={(event) => form.setData("name", event.target.value)}
        />
        <TextFieldComponent
          labelPosition="top"
          label="Quantidade de cotas"
          optional
          type="number"
          min="0"
          step="1"
          value={form.data.share_quantity}
          onChange={(event) => form.setData("share_quantity", event.target.value)}
        />
      </div>
    </FormModal>
  );
}
